<template>
  <HvhModal :value="true" :title="titleModal" :isLoading="isLoading" max-width="720" persistent @input="$emit('close')">
    <template v-slot>
      <v-form :class="{ readonly: readOnly }" @input="formValid = $event" ref="form">
        <v-text-field label="Product #" :disabled="!!formData.id" v-model="formData.productId" :rules="requiredRules" />
        <v-text-field label="Name" v-model="formData.name" :rules="requiredRules" />
        <v-text-field label="Description" v-model="formData.description" :rules="requiredRules" />
      </v-form>
    </template>
    <template v-slot:actions>
      <template v-if="!readOnly">
        <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')">Cancel</v-btn>
        <v-btn flat class="hvh-btn hvh-btn--primary" :class="{ disabled: wasValidated && !formValid }" @click="saveData">Save</v-btn>
      </template>
      <v-btn flat class="hvh-btn hvh-btn--secondary" @click="$emit('close')" v-else>Close</v-btn>
    </template>
  </HvhModal>
</template>

<script>
import cloneDeep from 'clone-deep';
export default {
  props: ['value', 'readOnly', 'isLoading'],
  data() {
    var requiredRules = [v => !!v || v === false || 'Field is required'];

    return {
      formData: cloneDeep(this.value) || {},
      requiredRules,
      numberRules: [
        ...requiredRules,
        v => (v > 0 && parseInt(v) == v) || 'You need to enter positive integer number',
      ],
      wasValidated: false,
      formValid: true,
    };
  },
  methods: {
    saveData() {
      this.wasValidated = true;
      if (!this.$refs.form.validate()) return;
      this.$emit('input', this.formData);
    },
  },
  computed: {
    titleModal() {
      return !this.formData.id ? "Add Product" : "Edit Product";
    }
  }
}
</script>